<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content" style="min-height: 500px">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Assign POS Device
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
              <div class="row">
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="account-name">Assign Device</label>
                    <multiselect
                        v-model="selectedDevice"
                        :options="deviceList"
                        label="label"
                        track-by="id"
                        placeholder="Select Device"
                        variant="primary"
                        :custom-label="customNameForMultiselect"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" :size="size"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data'],
  mounted() {

  },
  data() {
    return {
      size: "10px",
      id: '',
      imei: '',
      loading: false,
      url: "assign-pos-device-to-channel",
      deviceList: [],
      selectedDevice: '',
    };
  },
  methods: {
    getPosDevices(){
      let requestData = {
        status: 1,
      }
      this.makeRequest('post', 'v1/get-pos-device', requestData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.deviceList = callResponse.response?.data?.data ?? []
            if(this.deviceList.length > 0){
              let merchantChannelAssignPos = this.$store.getters.getByKey("merchantChannelAssignPos");

              if(merchantChannelAssignPos?.row?.pos_devices.length > 0){
                this.selectedDevice = this.deviceList.find((item) => item.id == merchantChannelAssignPos.row.pos_devices[0].id)
              }
            }
            // this.getAlreadySelectedChannels()
          }
        }

      });
    },
    customNameForMultiselect(val) {
      return val.name +'/'+ val.serial_number
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            channelId: this.id,
            posDeviceId: this.selectedDevice ? this.selectedDevice.id : 0
          }

          this.makeRequest("post", 'v1/assign-pos-device-to-channel', data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let responseData = callResponse.response.data.data;
                let storeData = this.$store.getters.getByKey("merchantChannelAssignPos");
                let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                let rowProp = {
                  ...storeData
                }
                rowProp.pos_devices = []

                if(responseData){
                  rowProp.pos_devices.push(this.selectedDevice)
                }
                rawdata[storeData.idx] = rowProp
                this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                this.$emit('hide')
                return
              }
            }
          });
        }
      });
    }
  },
  watch: {
    show(val) {
      if(val){
        let merchantChannelAssignPos = this.$store.getters.getByKey("merchantChannelAssignPos");
        this.index = merchantChannelAssignPos.row.index;
        this.id = merchantChannelAssignPos.row.id;
        this.getPosDevices()
      }else{
        this.selectedDevice = null
      }
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  overflow-y: auto;
}
</style>
